/**
 * Управление показом лоадера
 * @method
 * @private
 */

export default (sourceNode, parentNode, className) => {
  if (!sourceNode) { return; }

  const ajaxReviewNode = sourceNode.closest(parentNode);

  if (ajaxReviewNode) {
    ajaxReviewNode.classList.toggle(className);
  }
};
